import React from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import api from '../../ApiService';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';

import { ModalOKCancel } from '../../modals';
import GpoGroupsEditor from './GpoGroupsEditor';

import { toast } from 'react-toastify';


export default class GpoGroups extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            gpoGroups: [],
            sortedgpoGroups: [],
            gpoOptions: [],
            filter: 'select',
            loadingHospitals: false,
            showCancelModal: false
        };

        this.onSort = this.onSort.bind(this);
    }

    componentDidMount = async () => {
        let data = await api.getGpoGroups();
        let filter = data.gpoOptions[1].id;
        let sortedGpoGroups = data.gpoGroups.filter(x => x.gpoOptionId === data.gpoOptions[1].id);
        this.setState({
            gpoGroups: data.gpoGroups,
            gpoOptions: data.gpoOptions,
            sortedGpoGroups,
            filter
        });
    }

    onGpoSelect = async (e, rowData) => {
        this.setState({
            gpoOptionId: rowData.gpoOptionId,
            gpoOptionName: this.state.gpoOptions.find(x => x.id === rowData.gpoOptionId).name,
            gpoGroup: rowData,
            isEditing: true
        });
    }

    handleFilterChange = async (e) => {
        let filter = e.target.value;
        let sortedGpoGroups = this.state.gpoGroups.filter(x => x.gpoOptionId === filter);

        this.setState({ filter, sortedGpoGroups });
    }

    onConfirmCancel = async (e) => {
        // reload from server
        let data = await api.getGpoGroups();
        let sortedGpoGroups = data.gpoGroups.filter(x => x.gpoOptionId === this.state.filter);
        this.setState({
            gpoGroups: data.gpoGroups,
            gpoOptions: data.gpoOptions,
            sortedGpoGroups: sortedGpoGroups,
            isEditing: false,
            isDirty: false
        });
        toast.success("Changes canceled.");
    }

    onClickCancel = async (e) => {
        e.preventDefault();
        if (!this.state.isDirty) {
            await this.onConfirmCancel();
            return;
        }
        else {
            this.setState({ showCancelModal: true });
        }
    }

    onClickSave = async () => {
        let items = this.state.sortedGpoGroups;
        let item = items.find(item => item.id === 0);
        item.gpoOptionId = this.state.filter;
        let success = await api.saveGpoGroups(item);
        if (success) {
            let data = await api.getGpoGroups();
            let sortedGpoGroups = data.gpoGroups.filter(x => x.gpoOptionId === this.state.filter);
            this.setState({
                gpoGroups: data.gpoGroups,
                gpoOptions: data.gpoOptions,
                sortedGpoGroups: sortedGpoGroups,
                isDirty: false
            });
            toast.success(`GpoGroups updated.`);
        }
    }

    onEditorValueChange = (e) => {
        // just set the dirty flag
        if (!this.state.isDirty) this.setState({ isDirty: true });
    }

    onEditorBlur = (e, props) => {
        if (e.target.defaultValue === e.target.value) return;

        let items = [...props.value];
        if (items[props.rowIndex][props.field] !== e.target.value) {
            items[props.rowIndex][props.field] = e.target.value;
            this.setState({ items });
        }
    }

    onEditorKeyPress = (e, props) => {
        // have to manually handle this since onBlur doesn't make it to our control
        // yes, i'm a little upset about that
        // 9 - tab
        // 13- enter
        if (e.keyCode === 9 || e.keyCode === 13) {
            this.onEditorBlur(e, props);
        }
    }

    editTemplate = (props) => {
        return (
            <InputText type='text' defaultValue={props.rowData[props.field]}
                onBlur={(e) => this.onEditorBlur(e, props)}
                onChange={(e) => this.onEditorValueChange(e)}
                onKeyDown={(e) => this.onEditorKeyPress(e, props)}
            />
        );
    }

    onClickTemplate = (rowData, column) => {
        return <p onClick={(e) => this.onGpoSelect(e, rowData)}>{rowData.name}</p>;
    }

    onClickDelete = async (e) => {
        let success = await api.deleteGpoGroup(this.state.gpoGroup.id);
        if (success) {
            let data = await api.getGpoGroups();
            let sortedGpoGroups = data.gpoGroups.filter(x => x.gpoOptionId === this.state.filter);
            this.setState({
                gpoGroups: data.gpoGroups,
                gpoOptions: data.gpoOptions,
                sortedGpoGroups: sortedGpoGroups,
                isEditing: false,
                isDirty: false
            });
            toast.success(`GpoGroup removed.`);
        }
    }

    addItem = () => {
        // Check to see if there is already an empty one at the end
        if (!this.state.isDirty) {
            let sortedGpoGroups = this.state.sortedGpoGroups;
            let index = sortedGpoGroups.length;
            sortedGpoGroups[index] = { id: 0, name: '', index };
            this.setState({ sortedGpoGroups, isDirty: true });

            // forcing the focus to the newly added field
            let columns = document.getElementsByClassName("p-editable-column");
            setTimeout(() => columns[sortedGpoGroups.length - 1].click(), 200);
        }
        window.scrollTo(0, 9999);
    }

    onSort = (e) => {
        let sortedGpoGroups = [...this.state.sortedGpoGroups];
        sortedGpoGroups.sort((a, b) => {
            if (a.name === "") return 1;
            if (b.name === "") return -1;
            if (a.name === b.name) return 0;
            return e.order === 1 ? (a.name < b.name ? -1 : 1) : (a.name < b.name ? 1 : -1);
        });
        return sortedGpoGroups;
    }

    renderSaveCancel = (columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.addItem} disabled={this.state.isDirty}>Add</Button>
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.onClickCancel} disabled={!this.state.isDirty}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.onClickSave} disabled={!this.state.isDirty}>Save</Button>
            </Grid>
        );
    }

    renderFilterAndSaveCancel() {
        return (
            <Grid container spacing={0}>
                <Grid item xs={4}>
                    <FormControl fullWidth disabled={this.state.isDirty} >
                        <InputLabel htmlFor="filter" style={{ fontWeight: 'normal' }}>Filter</InputLabel>
                        <Select
                            value={this.state.filter}
                            onChange={this.handleFilterChange}
                            inputProps={{ name: 'filter', id: 'filter' }}
                        >
                            {this.state.gpoOptions.map((item, i) => {
                                return (
                                    <MenuItem key={i} value={item.id}>{item.name}</MenuItem>
                                );
                            })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                {this.renderSaveCancel(8)}
            </Grid>
        );
    }

    renderDetailsTable() {
        if (this.state.sortedGpoGroups) {
            return (
                <div>
                    <DataTable value={this.state.sortedGpoGroups} editable>
                        <Column field="name" header="Name" sortable="custom" sortFunction={this.onSort} style={{ width: '20%' }} body={this.onClickTemplate} editor={this.editTemplate} />
                    </DataTable>
                    <br />
                </div>
            );
        }
    }

    isActiveTemplate = (rowData, props) => {
        return (
            <Checkbox
                checked={rowData.isActive}
                onChange={(e) => this.onIsPrimaryChange(e, props.rowIndex)}
                value={`contacts[${props.rowIndex}].isPrimary`}
                color="primary"
            />
        );
    }

    renderCancelModal = () => {
        return (
            <ModalOKCancel
                title={"Discard changes"}
                body={"You have unsaved changes. Click OK to discard your changes."}
                show={this.state.showCancelModal}
                onOK={() => { this.onConfirmCancel(); this.setState({ showCancelModal: false }); }}
                onCancel={() => this.setState({ showCancelModal: false })}
            />
        );
    }

    render() {
        if (this.state.isEditing) {
            return (
                <GpoGroupsEditor
                    gpoOptionId={this.state.gpoOptionId}
                    gpoOptionName={this.state.gpoOptionName}
                    gpoGroup={this.state.gpoGroup}
                    onClickCancel={this.onClickCancel}
                    onClickDelete={this.onClickDelete}
                />
            );

        }
        else {
            let filterAndSaveCancel = this.renderFilterAndSaveCancel();
            let mappingDetails = this.renderDetailsTable();
            let gpoGroupHospitals = this.state.isEditing ? this.gpoGroupHospitals() : null;
            return (
                <div>
                    <h3>GPO Groups</h3>
                    <hr />
                    {filterAndSaveCancel}
                    <br />
                    <br />
                    {mappingDetails}
                    <br />
                    <br />
                    {gpoGroupHospitals}
                    <br />
                    {this.renderSaveCancel(12)}

                    {this.renderCancelModal()}
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/ManageGroups/GpoGroups.js